<template>
  <section class="cert-intro">
    <h2 class="cert-intro-title">{{ $t('certification.title') }}</h2>
    <p class="cert-intro-text">{{ $t('certification.text') }}</p>
  </section>
</template>

<script>
export default {
  name: 'CertificationIntro',
};
</script>

<style scoped>
.cert-intro {
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 40px;
}

@media screen and (min-width: 768px) {
  .cert-intro {
    padding-left: 24px;
    padding-right: 24px;
  }
}

@media screen and (min-width: 1024px) {
  .cert-intro {
    padding-left: 60px;
    padding-right: 60px;
  }
}

@media screen and (min-width: 1440px) {
  .cert-intro {
    padding-left: 80px;
    padding-right: 80px;
    margin-bottom: 60px;
  }
}

@media screen and (min-width: 1920px) {
  .cert-intro {
    padding-left: 120px;
    padding-right: 120px;
    margin-bottom: 80px;
  }
}

.cert-intro-title {
  margin: 32px 0 0;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 28px;
  line-height: 1.2;
  color: #000;
}

@media screen and (min-width: 768px) {
  .cert-intro-title {
    font-size: 36px;
  }
}

@media screen and (min-width: 1024px) {
  .cert-intro-title {
    margin-top: 60px;
    font-size: 40px;
  }
}

@media screen and (min-width: 1440px) {
  .cert-intro-title {
    font-size: 48px;
  }
}

@media screen and (min-width: 1920px) {
  .cert-intro-title {
    font-size: 54px;
  }
}

.cert-intro-text {
  margin: 16px 0 0;
  width: 100%;
  line-height: 1.2;
  font-size: 18px;
  font-weight: 400;
  color: #000;
}

@media screen and (min-width: 768px) {
  .cert-intro-text {
    margin-top: 24px;
  }
}

@media screen and (min-width: 1024px) {
  .cert-intro-text {
    font-size: 22px;
  }
}

@media screen and (min-width: 1440px) {
  .cert-intro-text {
    font-size: 24px;
  }
}

@media screen and (min-width: 1920px) {
  .cert-intro-text {
    font-size: 26px;
  }
}
</style>
